/**
 * @format
 */

import React from 'react';
import WeeklyLeaderboard from '../components/WeeklyLeaderboard';
import { AgentLeaderboardFilterInput } from '../types/leaderboard.types';

interface WeeklyLeaderboardContainerProps {
  filter?: AgentLeaderboardFilterInput;
  pollInterval?: number; // Auto-refetch interval in milliseconds (e.g., 30000 for 30 seconds)
}

/**
 * Container component for Weekly Leaderboard
 * Handles data fetching with filter params
 */
const WeeklyLeaderboardContainer: React.FC<WeeklyLeaderboardContainerProps> = ({
  filter,
  pollInterval = 60000, // Default to 1 minute
}) => {
  return <WeeklyLeaderboard filter={filter} pollInterval={pollInterval} />;
};

export default WeeklyLeaderboardContainer;
